import {
  FormControl,
  InputLabel,
  ListItem,
  MenuItem,
  Select,
  CircularProgress,
} from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect } from "react";
import { Cantiere, getCantieri } from "../../service/cantieri";

const FiltroCantiere = ({

  onSelectCantiere = (selected) => {}

} : {

  onSelectCantiere: (selected: string | null) => any

}) => {

  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [cantieri, setCantieri] = React.useState<Array<Cantiere>>([]);
  const [cantiereSelezionato, setCantiereSelezionato] = React.useState<any>(); 

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    
    scaricaCantieri();

  }, []);

  const scaricaCantieri = async () => {

    try {

      const result: any = await getCantieri();
      setCantieri(result.data);

    } catch (err: any) {

        enqueueSnackbar(err.message ? err.message : err, { variant: 'error' }); 

    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ListItem key={"cantiere"}>
      <FormControl fullWidth>
        <InputLabel id="select-cantiere-label">Cantiere</InputLabel>
        {isLoading === true ? (
          <CircularProgress />
        ) : (
          <Select
            labelId="select-cantiere-label"
            id="select-cantiere"
            label="Cantiere"
            onChange={(selected: any) => { 
              onSelectCantiere(selected.target.value.toString()); 
              setCantiereSelezionato(selected.target.value);
          }}>
            {cantieri.map((cantiere, key) => (
              <MenuItem key={key} value={cantiere.idcantiere}>
                {cantiere.nomecantiere}
              </MenuItem>
            ))}
          </Select>
        )}
      </FormControl>
    </ListItem>
  );
};

export default FiltroCantiere;
